import React from 'react'

interface FlutterButtonProps {
  text: string
  onPress: () => void
  disabled?: boolean
  isLoading?: boolean
  loadingText?: string
}

const FlutterButton: React.FC<FlutterButtonProps> = ({
  text,
  onPress,
  disabled = false,
  isLoading = false,
  loadingText
}) => {
  return (
    <button
      className="bg-flutter-button text-white font-medium transition-all duration-200 focus:outline-none w-full h-[66px] rounded-[clamp(12px,1.5vw,18px)] text-[clamp(14px,1.4vw,22px)] font-['IBM Plex Sans Arabic']  border border-white/20 flex items-center justify-center disabled:opacity-50 disabled:cursor-not-allowed disabled:transform-none disabled:shadow-none hover:bg-opacity-90 active:bg-opacity-80"
      onClick={onPress}
      disabled={disabled || isLoading}
    >
      {isLoading ? (
        <div className="flex items-center gap-1">
          <div className="animate-spin rounded-full h-5 w-5 border-b-2 border-white"></div>
          <span>{loadingText || 'Loading...'}</span>
        </div>
      ) : (
        text
      )}
    </button>
  )
}

export default FlutterButton
